import { render } from "./ConsentimientoModal.vue?vue&type=template&id=c9169336&scoped=true"
import script from "./ConsentimientoModal.vue?vue&type=script&lang=js"
export * from "./ConsentimientoModal.vue?vue&type=script&lang=js"

import "./ConsentimientoModal.vue?vue&type=style&index=0&id=c9169336&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9169336"]])

export default __exports__